import React from 'react'

export interface FilterChipsProps {
  chips: { key: string; label: string }[]
  onClear: () => void
  onRemove?: (key: string) => void
}

export default function FilterChips({ chips, onClear, onRemove }: FilterChipsProps) {
  // Implemented basic removable chips; leaving tooltip/a11y as TODOs
  // - [ ] Truncate long labels with tooltip
  // - [ ] Keyboard accessible remove buttons
  return (
    <div className="flex items-center gap-2 text-xs">
      {chips.map(c => (
        <span key={c.key} className="px-2 py-1 rounded bg-muted text-foreground/80 inline-flex items-center gap-1">
          <span className="max-w-[16rem] truncate" title={c.label}>{c.label}</span>
          {onRemove && (
            <button
              type="button"
              aria-label={`Remove ${c.label}`}
              className="ml-1 opacity-70 hover:opacity-100"
              onClick={() => onRemove(c.key)}
            >
              ×
            </button>
          )}
        </span>
      ))}
      {chips.length > 0 && (
        <button className="underline" onClick={onClear}>Clear</button>
      )}
    </div>
  )
}
